import { AccentColors, MainColors, } from '@1inch-community/models';
import { lazy } from '../lazy';
import { themeChange } from './theme-change';
import { themeInit } from './theme-init';
export class ThemeManager {
    constructor() {
        this.mainColorSettings = lazy(() => this.context.settings.getSetting('main-color-name', MainColors.systemSync));
        this.brandColorSettings = lazy(() => this.context.settings.getSetting('brand-color-name', AccentColors.community));
    }
    getActiveMainColor() {
        return this.mainColorSettings.value.value ?? MainColors.systemSync;
    }
    getActiveBrandColor() {
        return this.brandColorSettings.value.value ?? AccentColors.community;
    }
    async init(context) {
        this.context = context;
        const mainColorName = this.getActiveMainColor();
        const brandColorName = this.getActiveBrandColor();
        await themeInit(mainColorName, brandColorName);
    }
    async onChangeTheme(mainColorName, brandColorName, event) {
        this.mainColorSettings.value.setValue(mainColorName);
        this.brandColorSettings.value.setValue(brandColorName);
        return await themeChange(mainColorName, brandColorName, event);
    }
    async onChangeMainColor(mainColorName, event) {
        const brandColorName = this.getActiveBrandColor();
        await this.onChangeTheme(mainColorName, brandColorName, event);
    }
    async onChangeBrandColor(brandColorName, event) {
        const mainColorName = this.getActiveMainColor();
        await this.onChangeTheme(mainColorName, brandColorName, event);
    }
}
//# sourceMappingURL=theme-manager.js.map